import { render, staticRenderFns } from "./RegisterProgress.vue?vue&type=template&id=bf4cec4a&scoped=true&"
import script from "./RegisterProgress.vue?vue&type=script&lang=js&"
export * from "./RegisterProgress.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProgress.vue?vue&type=style&index=0&id=bf4cec4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4cec4a",
  null
  
)

export default component.exports